import React from 'react';
import {Tag} from 'antd';
import {formatHedgeQty, type HedgeCoverage} from '../../utils/hedgeMarks';

interface HedgeTagProps {
    /** 对冲覆盖率判定结果：full/partial 显示标识，null/undefined 不显示 */
    coverage?: HedgeCoverage | null;
    /** 对冲张数（展示为「对冲 N」）；缺省时仅显示「对冲」（如委托按单号前缀判定无数量口径） */
    qty?: number | null;
}

/**
 * 对冲来源标识（紫色 Tag，与辅助交易历史订单样式一致）
 * 全量对冲（对冲仓位==统一仓位）实心；部分对冲（对冲仓位<统一仓位）整体 50% 透明
 */
const HedgeTag: React.FC<HedgeTagProps> = ({coverage, qty}) => {
    if (!coverage) {
        return null;
    }
    const label = null != qty && Number.isFinite(qty) ? `对冲 ${formatHedgeQty(qty)}` : '对冲';
    return (
        <Tag color="purple"
             style={{marginLeft: 6, opacity: 'partial' === coverage ? 0.5 : 1}}>
            {label}
        </Tag>
    );
};

export default HedgeTag;
